import * as React from "react"
import { Container, Row, Col, Button } from "react-bootstrap" 
import { TextInput } from '@mantine/core';
import { Textarea } from '@mantine/core';
import { InputWrapper } from '@mantine/core';
import { Group } from '@mantine/core';
import { Select } from '@mantine/core';


const requestText = "Make an Appointment"
const requestFirstHeading = "For Guests Only"
const requestFirstParagraph = "Let go of your stress by choosing the most convenient spa environment. You can choose to have your treatment on the beach side, at the comfort of your room or balcony."
const requestSecondHeading = "Booking and Cancellation Policy"
const requestSecondParagraph = "We value your business and ask to respect the spa schedule & policies. Should you need to book, cancel or reschedule please notify us at least 24 hours in advance. Any cancellations with less than 24 hours of notice are subject to a cancellation fee amounting to the cost of the scheduled service."

function Appointments() {
	return (

    <div className="appointment-form">
        <Container>
            <Row>
                <Col sm="5">
                    <div className="main-text">
                        <h1>{requestText}</h1>
                        <h4><span>{requestFirstHeading}</span></h4>
                        <p>{requestFirstParagraph}</p>
                        <h4>{requestSecondHeading}</h4>
                        <p>{requestSecondParagraph}</p>
                    </div>
                </Col>
                <Col sm="7">
                    <div className="wrapper">
                    <div className="contact-form">


                        <InputWrapper
                            id="guest-name"
                            required
                            label="Your Name"
                        >
                            <Group grow>
                                <TextInput placeholder="First Name" id="guest-name" variant="default"/>
                                <TextInput placeholder="Last Name" id="guest-name" variant="default"/>
                            </Group>
                        </InputWrapper>

                        <InputWrapper
                            id="phone"
                            required
                            label="Phone Number"
                        >
                            <TextInput placeholder="Phone Number" id="phone" variant="default"/>
                        </InputWrapper>

                        <InputWrapper
                            id="email"
                            required
                            label="Email Address"
                        >
                            <TextInput placeholder="Email" id="email" variant="default"/>
                        </InputWrapper>

                        <InputWrapper
                            id="treatment"
                            label="Select a treatment"
                        >
                            <Select
                                placeholder="Click to choose" id="treatment"
                                data={[
                                    { value: '2342', label: 'Package: Heavenly Getaway' },
                                    { value: '9183', label: 'Package: Head-to-Toe' },
                                    { value: '2949', label: 'Package: Bride & Groom' },
                                    { value: '1101', label: 'Package: Paradise Delight' },
                                    { value: '7749', label: '60 Minute Massage' },
                                    { value: '4903', label: '90 Minute Massage' },
                                    { value: '9984', label: 'Facial' },
                                    { value: '6782', label: 'Body Scrub' },
                                    { value: '8843', label: 'Body Wrap' },
                                    { value: '3090', label: 'Pedi & Mani' },
                                    { value: '5664', label: 'Hair Treatment' },
                                ]}
                            />
                        </InputWrapper>

                        {/*<InputWrapper
                            id="preferred-date"
                            label="Date of session"
                            required
                        >
                            <DatePicker placeholder="Click to choose" id="preferred-date"/>
							</InputWrapper>*/}

                        


                        <InputWrapper
                            id="time"
                            label="Time"
                        >
                            <Select
                                placeholder="Choose a time" id="time"
                                data={[
                                    { value: 'a8oc', label: '8:00 AM' },
                                    { value: 'a8hf', label: '8:30 AM' },
                                    { value: 'a9oc', label: '9:00 AM' },
                                    { value: 'a9hf', label: '9:30 AM' },
                                    { value: 'a10oc', label: '10:00 AM' },
                                    { value: 'a10hf', label: '10:30 AM' },
                                    { value: 'a11oc', label: '11:00 AM' },
                                    { value: 'a11hf', label: '11:30 AM' },
                                    { value: 'a12oc', label: '12:00 PM' },
                                    { value: 'a12hf', label: '12:30 PM' },
                                    { value: 'a1oc', label: '1:00 PM' },
                                    { value: 'a1hf', label: '1:30 PM' },
                                    { value: 'a2oc', label: '2:00 PM' },
                                    { value: 'a2hf', label: '2:30 PM' },
                                    { value: 'a3oc', label: '3:00 PM' },
                                    { value: 'a3hf', label: '3:30 PM' },
                                    { value: 'a4oc', label: '4:00 PM' },
                                    { value: 'a4hf', label: '4:30 PM' },
                                    { value: 'a5oc', label: '5:00 PM' },
                                    { value: 'a5hf', label: '5:30 PM' },
                                    { value: 'a6oc', label: '6:00 PM' },
                                    { value: 'a6hf', label: '6:30 PM' },
                                    
                                    
                                ]}
                            />
                        </InputWrapper>

                        <InputWrapper
                            id="comment"
                            label="Additional comments or requests"
                        >
                            <Textarea placeholder="Type your message here..." id="comment" minRows={3} maxRows={6}/>
                        </InputWrapper>

                        <InputWrapper
                            id="submit"
                        >
                            <Button type="button" id="button-one-color"><h4>Send Request</h4></Button>
                        </InputWrapper>

					    </div>
                    </div>
                </Col>
            </Row>
        </Container>
	</div>

    );
}

export default Appointments;